import React from 'react';
import { Col, Row, FormGroup } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, PercentageBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class PercentageBoxDemo extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			form: {
				preset: 123456789
			}
		};
	}

	handleChange = (form) => {
		this.setState({ form });
	}

	handleSubmit = () => {
		Modals.alert(JSON.stringify(this.state.form));
	}

	handleUpdateForm = () => {
		const form = {
			...this.state.form,
			preset: 111,
			required: 222,
			disabled: 333444.55,
			default: 1234.56
		};

		this.setState({ form });
	}

	render() {
		return (
			<Box title="PercentageBox">
				<Form
					onChange={this.handleChange}
					onSubmit={this.handleSubmit}
					values={this.state.form}>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Default</Label>
								<PercentageBox name="default" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Placeholder</Label>
								<PercentageBox name="placeholder" placeholder="Total percentage" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Disabled</Label>
								<PercentageBox name="disabled" disabled={true} />
							</FormGroup>
						</Col>
					</Row>
					<Row>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default">Preset</Label>
								<PercentageBox name="preset" />
							</FormGroup>
						</Col>
						<Col md={4}>
							<FormGroup>
								<Label htmlFor="default" required>Required</Label>
								<PercentageBox name="required" required />
							</FormGroup>
						</Col>
						<Col md={4}>
						</Col>
					</Row>
					<hr />
					<div className="btn-toolbar">
						<Button id="btnUpdateForm" className="pull-left" onClick={this.handleUpdateForm}>Update Form</Button>
						<Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
					</div>
				</Form>
			</Box>
		)
	}
}

export default PercentageBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/PercentageBoxDemo.js